import { useContext } from 'react';
import { VirtualSlotsPlaceholderHighlightContext } from '../slotsPlaceholderContext';
export const useSlotHighlighting = (slotId) => {
    const highlightData = useContext(VirtualSlotsPlaceholderHighlightContext);
    return highlightData[slotId] === 'highlighted';
};
//# sourceMappingURL=useSlotHighlighting.js.map